import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import ContactModal from '../modals/ContactModal';

const AccountSuspendedNotice = () => {
    const [displayModal, updateModalVisibility] = useState(false);
    return (
        <div className="account-suspended-notice box-wrapper">
            <div className="blocked-account">
                <h3>
                    <FormattedMessage id="blocked.account.header" />
                </h3>
                <p>
                    <FormattedMessage
                        id="blocked.account.body"
                        values={{
                            contact: (
                                <span onClick={() => updateModalVisibility(true)}>
                                    <FormattedMessage id="blocked.account.contact" />
                                </span>
                            ),
                        }}
                    />
                </p>
            </div>
            <ContactModal onOk={() => updateModalVisibility(false)} visible={displayModal} />
        </div>
    );
};

export default AccountSuspendedNotice;
